import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { GETTERS as LEADERBOARD_GETTERS } from '@/store/leaderboard';
@Component({
  name: 'CmgLeaderboardFavorite',
})
export default class CmgLeaderboardFavorite extends Vue {

  get isInErrorState(): boolean {
    return this.$appStore.state.leaderboard.isInErrorState;
  }

  get hasNoEntree(): boolean {
    return this.entree === '';
  }

  get orderCount(): number {
    return this.$appStore.getters[LEADERBOARD_GETTERS.ORDER_COUNT];
  }

  get isInZeroState(): boolean {
    return this.orderCount === 0 || this.$appStore.state.leaderboard.statistics.nationalRankPercentage === 0;
  }

  get entree(): string {
    return this.$appStore.state.leaderboard.statistics.favoriteEntree;
  }

  get entreeText(): string {
    return (!this.hasNoEntree && !this.isInZeroState) ? this.entree : '--';
  }

  get isMobile(): boolean {
    return this.$services.ui.isMobile();
  }

  get whiteBoxImage(): string | undefined {
    return !this.isMobile
    ? this.$appStore.state.cms.images.loyalty.leaderboardWhiteBoxEntree.desktop
    : this.$appStore.state.cms.images.loyalty.leaderboardWhiteBoxEntree.mobile;
  }

  get entreeImageUrl(): string {
    return this.$appStore.state.leaderboard.statistics.favoriteEntreeImageUrl;
  }  

  get noEntreeImageUrl(): string {
    return this.$appStore.state.cms.images.loyalty.leaderboardPepperGrey.default;
  }
}
